import React from 'react';
import '../../styles/ProgressBar.css';

export default function ProgressBar({ current, total, progress, onGoBack, canGoBack }) {
  return (
    <div className="progress-bar-container">
      <div
        onClick={onGoBack}
        disabled={!canGoBack}
        title="Назад"
        className="go-back-desktop"
      >
        <svg width="21" height="18" viewBox="0 0 21 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M20.8599 7.02806V10.1641H8.42795L2.71595 9.71606V7.44806L8.42795 7.02806H20.8599ZM8.31595 5.74589e-05L10.3879 1.98806L2.65995 9.82806V7.36406L10.3879 15.2041L8.31595 17.1921L-5.46575e-05 8.59606L8.31595 5.74589e-05Z" fill="#1E1E1E"/>
        </svg>
          Повернутися
      </div>
      <button 
        className="go-back-btn"
        onClick={onGoBack}
        disabled={!canGoBack}
        title="Назад"
      >
        <svg width="10" height="15" viewBox="0 0 10 15" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M7.76709 12.7915L2.12134 7.14575L7.76709 1.5" stroke="#DB9BD4" strokeWidth="3" strokeLinecap="round"/>
        </svg>
      </button>
      
        <div className="progress-info">
          <span className="progress-text">
            {current}
          </span>
        </div>
        <div className="progress-bar">
          <div 
            className="progress-fill" 
            style={{ width: `${progress}%` }}
          >
          </div>
          <svg 
            style={{left: `${progress-1}%`}} 
            className="progress-decor" 
            width="18" 
            height="34" 
            viewBox="0 0 18 34" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M11.2891 12.6604L17.1733 14.3065C18.4811 15.1341 18.002 15.9917 17.3415 17.0249C13.7671 22.6165 9.46074 27.9202 5.8364 33.5004C4.89073 34.5332 3.27471 33.8531 3.32667 32.479L6.71662 20.0946L0.76161 18.431C-0.708415 17.3561 0.272576 16.3543 1.01557 15.2875C4.52631 10.2478 8.3729 5.43096 11.905 0.40456C12.9069 -0.467539 14.2798 0.155809 14.3596 1.45841L11.2889 12.6604H11.2891Z" fill="#5B5BD8"/>
          </svg>
        </div>
    </div>
  );
}